var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8L8.10764 12.6122L8.10967 12.6139C8.78785 13.1112 9.12714 13.36 9.49876 13.4561C9.82723 13.5411 10.1725 13.5411 10.501 13.4561C10.8729 13.3599 11.2132 13.1104 11.8926 12.6122L18 8M17.8002 7.03944L12.2012 2.55657C11.506 1.99995 11.1581 1.72174 10.7715 1.61126C10.4304 1.51378 10.0692 1.50861 9.72552 1.59661C9.33603 1.69634 8.98087 1.96473 8.27052 2.50188L2.26953 7.03967C1.8038 7.39184 1.57123 7.56804 1.40332 7.7906C1.2546 7.98772 1.14377 8.21065 1.07624 8.44817C1 8.71633 1 9.00832 1 9.59221V15.8001C1 16.9202 1 17.4805 1.21799 17.9083C1.40973 18.2847 1.71547 18.5904 2.0918 18.7822C2.5192 18.9999 3.07899 18.9999 4.19691 18.9999H15.8031C16.921 18.9999 17.48 18.9999 17.9074 18.7822C18.2837 18.5904 18.5905 18.2844 18.7822 17.9081C19 17.4807 19 16.9214 19 15.8035V9.52647C19 8.96932 19 8.68902 18.9287 8.4301C18.8651 8.19922 18.7595 7.98161 18.619 7.78768C18.4604 7.56876 18.2409 7.39227 17.8002 7.03944Z",
    stroke: "#A9B7BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b72e1c1a4fd76db3a7c6bf527400d8b9.svg";
export { ForwardRef as ReactComponent };